import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-electricity-place-actions',
  templateUrl: './place-actions.component.html',
  styleUrls: ['./place-actions.component.scss']
})
export class PlaceActionsComponent implements OnInit {

  @Input()
  public rowData: any;

  @Input()
  public value: any;

  public hasUserRights: boolean;

  @Output()
  public viewDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public addNewContract: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public viewExistingContracts: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public disassociateConsumptionPlace: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.value.company) {
      const permissions = this.value.company.permissionsDTO;
      this.hasUserRights = permissions.isOwner || permissions.canChangeSupplierContract;
    }
  }

  public viewDetailsAction(): void {
    this.viewDetails.emit(this.rowData);
  }

  public addNewContractAction(): void {
    // this.errorNotification('Momentan indisponibil.');
    this.addNewContract.emit(this.rowData);
  }

  public viewExistingContractsAction(): void {
    this.viewExistingContracts.emit(this.rowData);
  }

  public disassociateConsumptionPlaceAction(): void {
    this.disassociateConsumptionPlace.emit(this.rowData);
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

}
